"use client";

import { usePostHog } from "posthog-js/react";

import { Allergen } from "@/primary-models";

import { FlowNavigationContext } from "../constants";

import { useSignupFlowStore } from "./useSignUpFlowStore";

export const useFlowNavigationContext = (): FlowNavigationContext => {
  const posthog = usePostHog();
  const { cats } = useSignupFlowStore((state) => ({
    cats: state.cats,
  }));

  const inABTestGroup = (flag: string): boolean => {
    if (!posthog) { return false; }
    const flagValue = posthog.getFeatureFlag(flag);
    return flagValue === "test";
  };

  const hasAllAllergies = (excludedAllergies: Allergen[]): boolean => {
    const catsAllergies = Object.values(cats).flatMap((cat) => cat.diet?.foodAllergies?.allergens ?? []);
    return excludedAllergies.every((allergen) => catsAllergies.includes(allergen));
  };

  const constraints: FlowNavigationContext = {
    inABTestGroup,
    hasAllAllergies,
  };

  return constraints;
};
